import { SidebarTrigger } from "@/components/ui/sidebar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { KnowledgeBaseTab, GlossaryTab } from "@/components/docs";

export default function Docs() {
  return (
    <div className="flex flex-col min-h-screen">
      <header className="sticky top-0 z-10 flex h-16 items-center gap-4 border-b bg-card px-6">
        <SidebarTrigger />
        <div className="flex-1">
          <h1 className="text-lg font-semibold text-foreground">Documentation</h1>
        </div>
      </header>

      <div className="flex-1 p-6">
        <Tabs defaultValue="overview" className="space-y-6">
          <TabsList className="grid w-full grid-cols-3 lg:w-auto lg:inline-grid">
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="knowledge-base">Knowledge Base</TabsTrigger>
            <TabsTrigger value="glossary">Glossary</TabsTrigger>
          </TabsList>

          {/* Overview Tab */}
          <TabsContent value="overview" className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle>Welcome to Gravity Assist</CardTitle>
                <CardDescription>
                  Your comprehensive wine operations management system
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-sm text-muted-foreground">
                  Gravity Assist is an enterprise-grade platform designed to streamline winery workflows
                  from grape intake to bottling. The application manages work orders, operations scheduling,
                  client relationships, wine lots, vessels, lab testing, and quality control processes.
                </p>

                <div className="grid gap-4 md:grid-cols-2">
                  <div className="space-y-2">
                    <h4 className="text-sm font-semibold">Quick Start</h4>
                    <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside">
                      <li>Navigate using the sidebar menu</li>
                      <li>Start with Dashboard for an overview</li>
                      <li>Check Intake Center for new requests</li>
                      <li>Create work orders from intake requests</li>
                      <li>Track operations in real-time</li>
                    </ul>
                  </div>

                  <div className="space-y-2">
                    <h4 className="text-sm font-semibold">Key Features</h4>
                    <ul className="text-sm text-muted-foreground space-y-1 list-disc list-inside">
                      <li>Automated email ingestion</li>
                      <li>Real-time collaboration</li>
                      <li>Comprehensive audit trails</li>
                      <li>Lab testing & QC management</li>
                      <li>Client portal access</li>
                    </ul>
                  </div>
                </div>

                <Separator className="my-6" />

                {/* Colophon */}
                <div className="space-y-3">
                  <h4 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Colophon</h4>
                  <div className="text-sm text-muted-foreground leading-relaxed">
                    <p className="italic">
                      Gravity Assist was created through the collaborative efforts of{" "}
                      <span className="font-medium text-foreground">Brandon Holcombe</span>,{" "}
                      <span className="font-medium text-foreground">Jeff Pisoni</span>,{" "}
                      <span className="font-medium text-foreground">Caroline Davis</span>,{" "}
                      <span className="font-medium text-foreground">Claude Code</span>, and{" "}
                      <span className="font-medium text-foreground">ChatGPT-5</span>.
                    </p>
                    <p className="mt-2">
                      © {new Date().getFullYear()} Gravity Assist. All rights reserved.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          {/* Knowledge Base Tab */}
          <KnowledgeBaseTab />

          {/* Glossary Tab */}
          <GlossaryTab />
        </Tabs>
      </div>
    </div>
  );
}
